import { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { MobileHeader } from "../components/MobileHeader";
import { MobileCard } from "../components/MobileCard";

// AI 生成のサンプル出力（mock）
const sampleGenerated = `## AI時代のSEO対策完全ガイド: 2026年に必須の3つの戦略

### はじめに
検索エンジンのアルゴリズムは毎年大きく変化しています。
2026 年現在、AI 検索とユーザ意図の理解が最重要テーマです。

### 戦略1: E-E-A-T の徹底
経験・専門性・権威性・信頼性を示すコンテンツを制作しましょう。

### 戦略2: 構造化データのリッチ化
FAQ / HowTo / Product スキーマで検索結果を独占できます。

### 戦略3: AI 検索（SGE）対策
AI による要約に直接引用されるためのライティングが鍵です。

### まとめ
3 つの戦略を同時に走らせることで、2026 年の検索流入を最大化できます。`;

/**
 * モバイル AI ブログ生成ページ
 * 入力フォーム + ローディング + 生成結果（1 秒の擬似生成待ち）
 */
export const MobileAiBlogPage = () => {
  const [keyword, setKeyword] = useState("AI SEO");
  const [purpose, setPurpose] = useState("リード獲得");
  const [tone, setTone] = useState("プロフェッショナル");
  const [charCount, setCharCount] = useState("2000");
  const [target, setTarget] = useState("中小企業のマーケティング担当者");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<string | null>(null);

  const handleGenerate = () => {
    setResult(null);
    setLoading(true);
    // 1 秒後にサンプル結果を提示
    window.setTimeout(() => {
      setLoading(false);
      setResult(sampleGenerated);
    }, 1000);
  };

  return (
    <>
      <MobileHeader title="AI 記事生成" />
      <main className="mobile-content">
        <MobileCard title="生成条件">
          <div className="mobile-form-group">
            <label className="mobile-form-label">キーワード</label>
            <input
              type="text"
              className="mobile-form-input"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </div>

          <div className="mobile-form-group">
            <label className="mobile-form-label">目的</label>
            <select
              className="mobile-form-select"
              value={purpose}
              onChange={(e) => setPurpose(e.target.value)}
            >
              <option>リード獲得</option>
              <option>ブランディング</option>
              <option>商品販売</option>
              <option>採用</option>
            </select>
          </div>

          <div className="mobile-form-group">
            <label className="mobile-form-label">スタイル</label>
            <select
              className="mobile-form-select"
              value={tone}
              onChange={(e) => setTone(e.target.value)}
            >
              <option>プロフェッショナル</option>
              <option>カジュアル</option>
              <option>親しみやすい</option>
              <option>論理的</option>
            </select>
          </div>

          <div className="mobile-form-group">
            <label className="mobile-form-label">文字数</label>
            <input
              type="number"
              className="mobile-form-input"
              value={charCount}
              onChange={(e) => setCharCount(e.target.value)}
            />
          </div>

          <div className="mobile-form-group">
            <label className="mobile-form-label">ターゲット</label>
            <input
              type="text"
              className="mobile-form-input"
              value={target}
              onChange={(e) => setTarget(e.target.value)}
            />
          </div>

          <button
            type="button"
            className="mobile-btn mobile-btn-primary mobile-btn-block"
            onClick={handleGenerate}
            disabled={loading}
            style={{ marginTop: 6 }}
          >
            {loading ? (
              <>
                <Loader2 size={16} className="mobile-spinner" />
                生成中…
              </>
            ) : (
              <>
                <Sparkles size={16} strokeWidth={2} />
                AI 記事生成
              </>
            )}
          </button>
        </MobileCard>

        {loading && (
          <div className="mobile-loading">
            <span className="mobile-spinner" />
            AI が記事を生成しています…
          </div>
        )}

        {result && !loading && (
          <MobileCard title="生成結果">
            <div className="mobile-ai-result">{result}</div>
          </MobileCard>
        )}
      </main>
    </>
  );
};
